import Vue from "vue";

export async function getParentByEmail({ commit }, email) {
  commit("cleanErrors")
  await Vue.axios({
      method: "GET",
      url: `/parent/filter_by_params/?email=${email}`
    })
    .then((response) => {
      commit("setParentToShare", response.data)
    })
    .catch((error) => {
      commit("setParentToShare", null)
      commit("error", error)
    })
}

export async function parentAssignChildren({ commit }, data={parentId: 0, assignToParentId: 0, childList: [], canEdit: false}) {
  commit("cleanErrors")
  let returnValue = false;
  await Vue.axios({
      method: "POST",
      url: `/parent/${data.parentId}/assign_children/`,
      data: {
        "parent_to_assign": data.assignToParentId,
        "children": data.childList,
        "assign": true,
        "parent_can_edit": data.canEdit
      }
    })
    .then(() => {
      returnValue = true
    })
    .catch((error) => {
      commit("error", error)
    })
  return returnValue
}

export async function parentInviteChildren({ commit }, data={parentId: 0, assignToParentId: 0, childList: [], canEdit: false, email: '', name: '', lastName: ''}) {
  commit("cleanErrors")
  let returnValue = false;
  await Vue.axios({
      method: "POST",
      url: `/parent/${data.parentId}/invite_parent/`,
      data: {
        "email": data.email,
        "name": data.name,
        "last_name": data.lastName,
        "parent_who_invites": data.assignToParentId,
        "children_to_assign": data.childList,
        "parent_can_edit": data.canEdit
      }
    })
    .then(() => {
      returnValue = true
    })
    .catch((error) => {
      commit("error", error)
    })
    return returnValue
}